module.exports = __webpack_public_path__ + "img/tarj-afiliacion.f14e4a65.jpg";